<template>
  <ul class="list mt-2 mb-0! p-0! flex! flex-col gap-8" role="list">
    <li
      v-for="holder in holders"
      :key="holder.id"
      class="list-none m-0! p-0! flex flex-col gap-1"
    >
      <h4 class="text-xl my-0!">
        <span class="title">{{ holder.first_name }} {{ holder.middle_name }} {{ holder.last_name }}</span>
      </h4>
      <p v-if="holder.company">
        <span class="companyFilter">{{ holder.company }}</span><br>
      </p>
      <p class="flex flex-row">
        <span v-if="holder.city" class="cityFilter">{{ holder.city }}</span>
        <span v-if="holder.city && holder.state" class="mr-1">, </span>
        <span v-if="holder.state" class="stateFilter">{{ holder.state }}</span>
      </p>
      <p v-if="holder.country">
        <span class="countryFilter">{{ holder.country }}</span><br>
      </p>
      <p v-if="holder.email">
        <span>Email:&nbsp;</span>
        <a :href="`mailto:${holder.email}`">
          <span class="emailFilter">{{ holder.email }}</span>
        </a>
      </p>
      <ul class="pl-0! my-0!">
        <li v-for="cert in holder.certificates" :key="cert.slug" class="list-none">
          <a
            v-if="cert.live && cert.slug"
            class="no-underline text-red-600 hover:text-red-500 focus:text-red-500 active:text-red-500 hover:underline focus:underline active:underline"
            :href="cert.url"
          >{{ cert.title }}</a>
          <span v-else>{{ cert.title }} (No longer offered through SEI)</span>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script setup lang="ts">
defineProps<{
  holders: Array<{
    id: string | number
    first_name: string
    middle_name?: string
    last_name: string
    company?: string
    city?: string
    state?: string
    country?: string
    email?: string
    certificates: Array<{
      title: string
      slug: string | null
      url: string | null
      live: boolean
    }>
  }>
}>()
</script>
